module.exports = __webpack_public_path__ + "images/c7c928994543bbad3d8907cd9ae9bf77-Roboto-Light.svg";